import { assign, createMachine, sendParent, spawn } from 'xstate';
import { interval } from 'rxjs';
import { map } from 'rxjs/operators';
import { CounterInterface, STATES, GUARDS, EVENTS, ACTIONS } from '../../interfaces/countDownInterface';

const createCounterObservable = (ms:number) => interval(ms).pipe(
  map((i) => ({ type: 'TICK', value: i })),
);

const initialState:CounterInterface = {
  ms: 1000,
  counterRef: null,
  isAutoStart: true,
  callback: '',
};
export const counterMachine = createMachine<CounterInterface>({
  predictableActionArguments: true,
  id: 'counterObservable',
  initial: STATES.IDLE,
  context: initialState,
  states: {
    [STATES.IDLE]: {
      always: [
        {
          target: [STATES.COUNTING],
          cond: GUARDS.IS_AUTO_START,
        },
      ],
      on: {
        [EVENTS.START]: {
          target: [STATES.COUNTING],
        },
      },
    },
    [STATES.COUNTING]: {
      entry: [ACTIONS.INIT_OBSERVER],
      on: {
        [EVENTS.TICK]: {
          actions: [sendParent((context) => ({ type: context.callback }))],
        },
      },
    },
  },
}, {
  actions: {
    [ACTIONS.INIT_OBSERVER]: assign({
      counterRef: ({ ms }) => spawn(createCounterObservable(ms)),
    }),
  },
  guards: {
    [GUARDS.IS_AUTO_START]: (context) => context.isAutoStart,
  },
});
